import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { ThumbnailList } from '../ThumbnailList';

import { getClientName } from '../../../../../constants/baseurl';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../Accordion';
import { Icons } from '../Icons';

const StudyItem = ({
  date,
  description,
  numInstances,
  modalities,
  isActive,
  onClick,
  isExpanded,
  displaySets,
  activeDisplaySetInstanceUIDs,
  onClickThumbnail,
  onDoubleClickThumbnail,
  onClickUntrack,
  viewPreset = 'thumbnails',
  // onThumbnailContextMenu,
  ThumbnailMenuItems,
  StudyMenuItems,
  StudyInstanceUID,
}: withAppTypes) => {
  const urlParams = new URLSearchParams(window.location.search);
  const studyInstanceUIDs = urlParams.get('StudyInstanceUIDs');
  const patientName = urlParams.get('PatientName');
  const studies = studyInstanceUIDs?.includes(',') ? studyInstanceUIDs.split(',') : [];
  const paths = patientName?.includes(',') ? patientName.split(',') : [];

  const removePriorStudy = e => {
    e.stopPropagation();
    e.preventDefault();
    const newParams = new URLSearchParams(window.location.search);
    const updatedStudies = studies.filter(uid => uid !== StudyInstanceUID);
    newParams.set('StudyInstanceUIDs', updatedStudies.join(','));

    if (paths.length > 0) {
      const updatedPaths = paths.filter(uid => uid !== StudyInstanceUID);
      newParams.set('PatientName', updatedPaths.join(','));
    }

    const newUrl = `${window.location.pathname}?${newParams.toString()}`;
    window.location.href = newUrl;
  };

  return (
    <Accordion
      type="single"
      collapsible
      onClick={onClick}
      onKeyDown={() => { }}
      role="button"
      tabIndex={0}
      defaultValue={isActive ? 'study-item' : undefined}
    >
      <AccordionItem value="study-item">
        <AccordionTrigger
          className={classnames(
            'dark:hover:bg-primary-darkTable hover:bg-primary-lightblue dark:bg-primary-newgray bg-primary-gray rounded'
          )}
        >
          <div
            className={`flex ${studies.length > 0 && studies[studies.length - 1] === StudyInstanceUID ? 'h-[35px]' : 'h-[20px]'} flex-1 flex-row`}
          >
            <div className="flex w-full flex-row items-center justify-between">
              <div className="flex flex-col items-start text-[13px]">
                <div className="text-black dark:text-white">
                  {!['mrc', 'demo_mrc'].includes(getClientName()) && `${date}`}{' '}
                  {!['mrc', 'demo_mrc'].includes(getClientName()) && `(${modalities})`}
                  {['mrc', 'demo_mrc'].includes(getClientName()) && `DOS: ${displaySets?.find(item => item.displaySetInstanceUID === activeDisplaySetInstanceUIDs?.[0])?.studyDate || "N/A"}`}
                  {studies[studies.length - 1] === StudyInstanceUID && (
                    <div className="mt-2 block w-full text-black dark:text-white">
                      (Original Case)
                    </div>
                  )}
                </div>
                {/* <div className="dark:text-muted-foreground text-primary-main h-[18px] max-w-[160px] overflow-hidden truncate whitespace-nowrap">
                  {description}
                </div> */}
              </div>
              {studies.length > 0 && studies[studies.length - 1] !== StudyInstanceUID && (
                <span
                  title="Remove Study"
                  onClick={removePriorStudy}
                >
                  <Icons.ByName
                    name="delete-icon"
                    className="text-red-500"
                  />
                </span>
              )}
              {/* <div className="dark:text-muted-foreground text-primary-main mr-2 flex flex-col items-end text-[12px]">
                <div className="max-w-[150px] overflow-hidden text-ellipsis">{modalities}</div>
                <div>{numInstances}</div>
              </div> */}
              {StudyMenuItems && (
                <div className="ml-2 flex items-center">
                  <StudyMenuItems StudyInstanceUID={StudyInstanceUID} />
                </div>
              )}
            </div>
          </div>
        </AccordionTrigger>
        <AccordionContent
          onClick={event => {
            event.stopPropagation();
          }}
        >
          {isExpanded && displaySets && (
            <ThumbnailList
              thumbnails={displaySets}
              activeDisplaySetInstanceUIDs={activeDisplaySetInstanceUIDs}
              onThumbnailClick={onClickThumbnail}
              onThumbnailDoubleClick={onDoubleClickThumbnail}
              onClickUntrack={onClickUntrack}
              viewPreset={viewPreset}
              // onThumbnailContextMenu={onThumbnailContextMenu}
              ThumbnailMenuItems={ThumbnailMenuItems}
            />
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

StudyItem.propTypes = {
  date: PropTypes.string.isRequired,
  description: PropTypes.string,
  modalities: PropTypes.string.isRequired,
  numInstances: PropTypes.number.isRequired,
  // trackedSeries: PropTypes.number,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool,
  displaySets: PropTypes.array,
  activeDisplaySetInstanceUIDs: PropTypes.array,
  onClickThumbnail: PropTypes.func,
  onDoubleClickThumbnail: PropTypes.func,
  onClickUntrack: PropTypes.func,
  viewPreset: PropTypes.string,
  StudyMenuItems: PropTypes.func,
  StudyInstanceUID: PropTypes.string,
};

export { StudyItem };
